var map = {
	"./Shahipaneer.jpeg": "./src/assets/images/Shahipaneer.jpeg",
	"./amexcard.png": "./src/assets/images/amexcard.png",
	"./android.png": "./src/assets/images/android.png",
	"./androidtv.png": "./src/assets/images/androidtv.png",
	"./apple.png": "./src/assets/images/apple.png",
	"./appletv.png": "./src/assets/images/appletv.png",
	"./back.png": "./src/assets/images/back.png",
	"./banner.png": "./src/assets/images/banner.png",
	"./banner1.png": "./src/assets/images/banner1.png",
	"./calendar.svg": "./src/assets/images/calendar.svg",
	"./categories.svg": "./src/assets/images/categories.svg",
	"./clipboard.svg": "./src/assets/images/clipboard.svg",
	"./dashboard.svg": "./src/assets/images/dashboard.svg?9f33",
	"./dashboard_icon.svg": "./src/assets/images/dashboard_icon.svg",
	"./devices.png": "./src/assets/images/devices.png",
	"./gear-solid.svg": "./src/assets/images/gear-solid.svg?e82b",
	"./help.svg": "./src/assets/images/help.svg",
	"./home.svg": "./src/assets/images/home.svg?71c6",
	"./livechannel.png": "./src/assets/images/livechannel.png",
	"./liveseries.png": "./src/assets/images/liveseries.png",
	"./logo.jpg": "./src/assets/images/logo.jpg",
	"./logo.svg": "./src/assets/images/logo.svg",
	"./logout.png": "./src/assets/images/logout.png",
	"./non-veg.png": "./src/assets/images/non-veg.png",
	"./onlinedevices.png": "./src/assets/images/onlinedevices.png",
	"./onlinewatchingplaylist.png": "./src/assets/images/onlinewatchingplaylist.png",
	"./paneer.jpg": "./src/assets/images/paneer.jpg",
	"./payments.svg": "./src/assets/images/payments.svg",
	"./phone.svg": "./src/assets/images/phone.svg",
	"./posts.svg": "./src/assets/images/posts.svg",
	"./projects.svg": "./src/assets/images/projects.svg",
	"./share.svg": "./src/assets/images/share.svg",
	"./smooth-reason-412207-ec0ab83842b5": "./src/assets/images/smooth-reason-412207-ec0ab83842b5.json",
	"./smooth-reason-412207-ec0ab83842b5.json": "./src/assets/images/smooth-reason-412207-ec0ab83842b5.json",
	"./tattoo.svg": "./src/assets/images/tattoo.svg",
	"./totaldevices.png": "./src/assets/images/totaldevices.png",
	"./totalsubscriptions.png": "./src/assets/images/totalsubscriptions.png",
	"./user.jpeg": "./src/assets/images/user.jpeg",
	"./users.svg": "./src/assets/images/users.svg",
	"./veg.png": "./src/assets/images/veg.png",
	"./vendor.png": "./src/assets/images/vendor.png",
	"./watchingmovies.png": "./src/assets/images/watchingmovies.png",
	"./welcome_img.png": "./src/assets/images/welcome_img.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";